module.exports = __webpack_public_path__ + "img/電気回路_2_4_1.42c56ce6.png";